import React from 'react';

import { link } from '../../helpers/link';
import './MedicalVerificationBanner.scss';
import icons from '../../shared/assets/icons';

const { Cross } = icons;

export default function MedicalVerificationBanner(props) {
  return (
    <section id="medicalVerificationBanner">
      <div>
        <Cross />
        {link(
          <p>
            Deze informatie is geverifieerd door onze deskundige:{' '}
            {props.verifier.displayName}
          </p>,
          props.verifier.link,
          props.nextLink
        )}
      </div>
    </section>
  );
}
